<ng-container *ngIf="control?.errors">
  <small *ngIf="control?.errors">
    <span *ngIf="(control?.errors)!['required']">
      <ng-container *ngIf="control?.parent?.get('workDays') === control">
        <span class="text-danger"
          ><i class="isax isax-info-circle"></i
        ></span>
      </ng-container>
      {{ 'SHARED.VALIDATION.REQUIRED' | translate }}
    </span>

    <span *ngIf="(control?.errors)!['whitespace']">{{
      'SHARED.VALIDATION.WHITESPACE' | translate
    }}</span>

    <span *ngIf="(control?.errors)!['invalidName']">{{
      'SHARED.VALIDATION.INVALID_NAME' | translate
    }}</span>

    <span *ngIf="(control?.errors)!['duplicateName']">{{
      'SHARED.VALIDATION.DUPLICATE_NAME' | translate
    }}</span>

    <span *ngIf="(control?.errors)!['unsafeText']">{{
      'SHARED.VALIDATION.UNSAFE_TEXT' | translate
    }}</span>

    <span *ngIf="(control?.errors)!['maxlength']">{{
      'SHARED.VALIDATION.MAX_LENGTH'
        | translate
          : { length: (control?.errors)!['maxlength']?.requiredLength }
    }}</span>

    <span *ngIf="(control?.errors)!['minlength']">{{
      'SHARED.VALIDATION.MIN_LENGTH'
        | translate
          : { length: (control?.errors)!['minlength']?.requiredLength }
    }}</span>

    <span *ngIf="(control?.errors)!['pattern']">
      <span [ngSwitch]="(control?.errors)!['pattern']?.requiredPattern">
        <span *ngSwitchCase="userNamePattern">{{
          'SHARED.VALIDATION.PATTERN_USERNAME' | translate
        }}</span>
        <span *ngSwitchCase="mustNumberPattern">{{
          'SHARED.VALIDATION.PATTERN_NUMBER' | translate
        }}</span>
        <span *ngSwitchCase="numberMoreThanZeroPattern">{{
          'SHARED.VALIDATION.PATTERN_NUMBER_GT_ZERO' | translate
        }}</span>
        <span *ngSwitchDefault>{{
          'SHARED.VALIDATION.PATTERN_DEFAULT' | translate
        }}</span>
      </span>
    </span>

    <span *ngIf="(control?.errors)!['email']">{{
      'SHARED.VALIDATION.EMAIL' | translate
    }}</span>
    <span *ngIf="(control?.errors)!['invalidUrl']">{{
      'SHARED.VALIDATION.INVALID_URL' | translate
    }}</span>
    <span *ngIf="(control?.errors)!['saudiMobile']">{{
      'SHARED.VALIDATION.SAUDI_MOBILE' | translate
    }}</span>
    <span *ngIf="(control?.errors)!['mobile']">{{
      'SHARED.VALIDATION.MOBILE' | translate
    }}</span>
    <span *ngIf="(control?.errors)!['startsWithNumber']">{{
      'SHARED.VALIDATION.STARTS_WITH_NUMBER' | translate
    }}</span>
    <span *ngIf="(control?.errors)!['outsideAcademyDays']">{{
      'SHARED.VALIDATION.OUTSIDE_ACADEMY_DAYS' | translate
    }}</span>
    <span *ngIf="(control?.errors)!['academyDaysMissing']">{{
      'SHARED.VALIDATION.ACADEMY_DAYS_MISSING' | translate
    }}</span>
    <span *ngIf="(control?.errors)!['outsideAcademyTime']">{{
      outsideAcademyTimeMessage
    }}</span>
    <span *ngIf="(control?.errors)!['academyTimeMissing']">{{
      'SHARED.VALIDATION.ACADEMY_TIME_MISSING' | translate
    }}</span>
    <span *ngIf="(control?.errors)!['endBeforeStart']">{{
      'SHARED.VALIDATION.END_BEFORE_START' | translate
    }}</span>
    <span *ngIf="(control?.errors)!['sameAsPrimaryPhone']">{{
      'SHARED.VALIDATION.SAME_AS_PRIMARY_PHONE' | translate
    }}</span>
    <span *ngIf="(control?.errors)!['server']">{{ serverErrorMessage }}</span>
    <span *ngIf="(control?.errors)!['invalidDate']">{{
      'SHARED.VALIDATION.INVALID_DATE' | translate
    }}</span>
    <span
      *ngIf="
        control?.parent?.hasError &&
        control?.parent?.hasError('sameDate') &&
        control?.parent?.get('to_date') === control
      "
    >
      {{ 'SHARED.VALIDATION.SAME_DATE' | translate }}
    </span>
    <span
      *ngIf="
        control?.parent?.hasError &&
        control?.parent?.hasError('dateRange') &&
        control?.parent?.get('to_date') === control
      "
    >
      {{ 'SHARED.VALIDATION.DATE_RANGE' | translate }}
    </span>

    <span *ngIf="(control?.errors)!['min']">{{
      'SHARED.VALIDATION.MIN' | translate : { min: (control?.errors)!['min']?.min }
    }}</span>

    <span *ngIf="(control?.errors)!['max']">{{
      'SHARED.VALIDATION.MAX' | translate : { max: (control?.errors)!['max']?.max }
    }}</span>
    <span *ngIf="(control?.errors)!['maxInWarehouse']">{{
      'SHARED.VALIDATION.MAX_IN_WAREHOUSE'
        | translate : { max: (control?.errors)!['maxInWarehouse']?.max }
    }}</span>

    <span *ngIf="(control?.errors)!['minAge']">{{
      'SHARED.VALIDATION.MIN_AGE'
        | translate : { age: (control?.errors)!['minAge']?.requiredAge }
    }}</span>

    <span *ngIf="(control?.errors)!['wholePositiveNumber']">{{
      'SHARED.VALIDATION.WHOLE_POSITIVE_NUMBER' | translate
    }}</span>

    <span
      *ngIf="
        !(control?.errors)!['invalidDate'] &&
        !(control?.parent?.hasError('sameDate') &&
          control?.parent?.get('to_date') === control) &&
        !(control?.parent?.hasError('dateRange') &&
          control?.parent?.get('to_date') === control) &&
        !(control?.errors)!['maxInWarehouse'] &&
        !(control?.errors)!['wholePositiveNumber'] &&
        !(control?.errors)!['minAge'] &&
        !(control?.errors)!['unsafeText'] &&
        !(control?.errors)!['invalidName'] &&
        !(control?.errors)!['duplicateName'] &&
        !(control?.errors)!['required'] &&
        !(control?.errors)!['maxlength'] &&
        !(control?.errors)!['minlength'] &&
        !(control?.errors)!['pattern'] &&
        !(control?.errors)!['email'] &&
        !(control?.errors)!['invalidUrl'] &&
        !(control?.errors)!['saudiMobile'] &&
        !(control?.errors)!['mobile'] &&
        !(control?.errors)!['whitespace'] &&

        !(control?.errors)!['startsWithNumber'] &&
        !(control?.errors)!['outsideAcademyDays'] &&
        !(control?.errors)!['academyDaysMissing'] &&
        !(control?.errors)!['outsideAcademyTime'] &&
        !(control?.errors)!['academyTimeMissing'] &&
        !(control?.errors)!['endBeforeStart'] &&
        !(control?.errors)!['sameAsPrimaryPhone'] &&
        !(control?.errors)!['server'] &&
        !(control?.errors)!['min'] &&
        !(control?.errors)!['max']
      "
    >
      {{ 'SHARED.VALIDATION.INVALID_INPUT' | translate }}
    </span>
  </small>
</ng-container>
